import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

interface LoggedInWrapperProps {
  children?: ReactNode; // Make children optional for React Router v6 compatibility
}

const LoggedInWrapper: React.FC<LoggedInWrapperProps> = ({
  children: _children,
}): React.ReactElement => {
  const [showSidebar] = useState<boolean>(true); //FIX disable dragging
  // width/drag are handler-only (never drive JSX) — refs avoid needless re-renders
  const widthRef = useRef(80);
  const dragRef = useRef({ active: false, x: 0 });

  useEffect(() => {
    const resizeFrame = (e: MouseEvent) => {
      const { active, x } = dragRef.current;
      if (!active) return;
      const xDiff = Math.abs(x - e.clientX);
      const newW = x > e.clientX ? widthRef.current - xDiff : widthRef.current + xDiff;
      dragRef.current = { ...dragRef.current, x: e.clientX };
      widthRef.current = newW;
    };

    const stopResize = () => {
      dragRef.current = { ...dragRef.current, active: false };
    };

    window.addEventListener('mousemove', resizeFrame);
    window.addEventListener('mouseup', stopResize);
    return () => {
      window.removeEventListener('mousemove', resizeFrame);
      window.removeEventListener('mouseup', stopResize);
    };
  }, []);

  return (
    <div className={'flex h-[calc(100dvh-1px)] max-h-screen  flex-col overflow-hidden'}>
      <Outlet context={{ showSidebar: showSidebar }} />
    </div>
  );
};

export default LoggedInWrapper;
